/**
 * 鼠标右键组件
 */
import React, { Component } from 'react';
import "./ContextMenu.scss"
export default class ContextMenu extends Component {
    dom = null;
    constructor(props) {
        super(props)
        this.state = {
            X: 0,
            Y: 0,
            visable: false,
            itemList: [
                { label: "查看属性", key: "view" },
                { label: "删除", key: "delete" },
                { label: "添加", key: "add" },
            ]
        }
    }
    componentDidMount() {
        this.dom && this.dom.addEventListener("contextmenu", this.onMenu);
        window.addEventListener("click",this.closeMenu);
        window.addEventListener("contextmenu",this.closeMenu);
    }
    componentDidUpdate() {

    }
    componentWillUnmount() {
        this.dom && this.dom.removeEventListener("contextmenu", this.onMenu);
        window.removeEventListener("click",this.closeMenu);
        window.removeEventListener("contextmenu",this.closeMenu);
    }
    onMenu = (e) => {
        console.log(e);
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            visable:true,
            X:e.clientX,
            Y:e.clientY
        });
    }
    closeMenu = (e) => {
        this.setState({
            visable:false,
        });
    }
    _onItemClick = (val) => {
        this.props.onAction&&this.props.onAction(val);
    }

    handleEnter=(el)=>{
        el.style.height = "auto";
        const h = el.clientHeight;
        el.style.height = 0;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                el.style.height = h + "px";
                el.style.transition = "0.5s";
            });
        });
    }
    handleAfterEnter=(el)=>{
        el.style.transition = "none";
    }
    handleBeforeEnter=(el)=>{
        el.style.height = 0;
    }
    render() {
        let { itemList, visable,X,Y } = this.state;
        let { children } = this.props;
        return (
            <div className="context-menu" ref={ref => this.dom = ref}>
                {children}
                {
                    visable && <div className="menu-list" style={{top:Y,left:X}}>
                        {
                            itemList.map(m => {
                                return <div className="menu-item" key={m.key} onClick={() => this._onItemClick(m)}>{m.label}</div>
                            })
                        }
                    </div>
                }
            </div>
        )
    }
}